const triggers = document.body.querySelectorAll('.js-non-rap-modal-trigger');
const defaultOpenModals = document.body.querySelectorAll('.js-non-rap-modal--default-open');

const closeModal = (modal) => {
  const closeButton = modal.querySelector('.js-non-rap-modal__close');
  closeButton.addEventListener('click', () => {
    modal.close();
  });
};

const triggerModals = () => {
  defaultOpenModals.forEach((modal) => {
    modal.showModal();
    closeModal(modal);
  });
  triggers.forEach((trigger) => {
    const modalId = trigger.dataset.triggerfor;
    const modal = document.getElementById(modalId);

    trigger.addEventListener('click', () => {
      modal.showModal();
    });
    closeModal(modal);
  });
};

export default triggerModals;



// WEBPACK FOOTER //
// ./src/components/components/consumer/non-rap-modal/non-rap-modal.js